<div class="row">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            Do you require risers?
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <ng-select
            [(ngModel)]="product.riserRequired"
            (ngModelChange)="toggleRiserRequired()"
            [clearable]="false"
            [searchable]="false"
            class="dark">
            <ng-option [value]="true">Yes</ng-option>
            <ng-option [value]="false">No</ng-option>
        </ng-select>

    </div>
</div>


<div class="row" *ngIf="product.riser">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            Height
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <div class="input-group">
            <input
                type="number"
                class="form-control"
                [ngClass]="{
                'border-danger' : product.riser.height < 80 || product.riser.height > 250}"
                [(ngModel)]="product.riser.height" />
            <span class="input-group-text">mm</span>
            <span class="text-danger" *ngIf="product.riser.height < 80 || product.riser.height > 250">
            Riser height must be between 80 and 250mm
        </span>
            <span class="text-danger" *ngIf="product.riser.height % 5 !== 0">
            Riser height must be multiple of 5
        </span>
        </div>

    </div>
</div>

<div class="row" *ngIf="product.riser">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            Thickness
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <ng-select
            [(ngModel)]="product.riser.thickness"
            (ngModelChange)="calcBespokeCost()"
            [clearable]="false"
            [searchable]="false"
            class="dark">
            <ng-option [value]="30">30mm</ng-option>
            <ng-option [value]="40">40mm</ng-option>
        </ng-select>


    </div>
</div>
